module.exports = __webpack_public_path__ + "img/ic_contentitem_playlist.3a9fbfdd.svg";